import { inject, Pipe, PipeTransform } from '@angular/core';
import { GlobalDataStorageService } from '@dash/randy/security/service/global-data-storage.service';
import { environment } from '../../../environments/environment';
import {FileHelperService} from "../../modules/file-manager/services/file-helper.service";
import {FileManagerItem} from "../../modules/file-manager/classes/file-manager.model";

@Pipe({
    name: 'imgCdnLink',
})
export class ImgCdnLinkPipe implements PipeTransform {
  public baseUrl = environment.cdnUrl;

  private fileHelperService: FileHelperService = inject(FileHelperService);

  constructor() {}

  transform(item: FileManagerItem | string, thumb = true): string {
    if (!item) {
      return '';
    }
    let itemId = '';
    if (typeof item === 'object') {
      itemId = item.id;
    } else {
      itemId = item;
    }

    if (thumb) {
      return this.fileHelperService.getThumbnailUrl(itemId);
    }

    return this.fileHelperService.getOriginalUrl(itemId);
  }
}
